export default "/imgs/promo-txt-1.png"